import React, { useState } from 'react';
import { motion } from 'motion/react';
import SettingsSidebar from './components/SettingsSidebar';
import SettingsContent from './components/SettingsContent';
import { useAppDispatch } from '@/data/store/utils/redux';
import { sessionLogout, storeOrganizationId } from '@/data/store/actions';

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState('security');

  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(sessionLogout());
  };

  const handleOrgChange = () => {
    dispatch(storeOrganizationId(null));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50/50 via-white to-blue-50/30 p-6">
      {/* Subtle decorative elements */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 right-1/4 h-64 w-64 rounded-full bg-gradient-to-br from-blue-100/5 to-purple-100/5 blur-3xl"></div>
        <div className="absolute bottom-1/4 left-1/4 h-48 w-48 rounded-full bg-gradient-to-br from-emerald-100/5 to-teal-100/5 blur-2xl"></div>
      </div>

      <div className="relative z-10 mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex gap-8"
        >
          {/* Sidebar */}
          <SettingsSidebar
            onLogout={handleLogout}
            onOrganizationSelect={handleOrgChange}
            activeTab={activeTab}
            onTabChange={setActiveTab}
          />

          {/* Main Content */}
          <SettingsContent activeTab={activeTab} />
        </motion.div>
      </div>
    </div>
  );
};

export default Settings;
